import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi, type Refund, type ReturnRequest } from '../../api/returns';

export function RefundDashboardPage() {
  const [refunds, setRefunds] = useState<Refund[]>([]);
  const [returns, setReturns] = useState<ReturnRequest[]>([]);

  useEffect(() => {
    void Promise.all([returnsApi.listRefunds(), returnsApi.listReturns()])
      .then(([r, ret]) => { setRefunds(r); setReturns(ret); });
  }, []);

  async function createRefund(ret: ReturnRequest) {
    await returnsApi.createRefund({ return_id: ret.id, amount: ret.refund_amount });
    setRefunds(await returnsApi.listRefunds());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Refund dashboard</h1>
      <ul className="mt-4 space-y-2 text-sm">
        {refunds.map((f) => (
          <li key={f.id} className="rounded border p-3">{f.refund_number} — {f.status} · ₹{f.amount}</li>
        ))}
      </ul>
      {returns.length > 0 && (
        <button type="button" onClick={() => void createRefund(returns[0])}
          className="mt-4 rounded bg-slate-900 px-4 py-2 text-sm text-white">
          Create refund for first return
        </button>
      )}
    </div>
  );
}
